import React from 'react';
import { generateClassName } from './helpers';
import { Tooltip } from '@mui/material';

import './BooleanIconToggle.css';

const BooleanIconToggle = ({ value, onChange, trueIcon: TrueIcon, falseIcon: FalseIcon, className = null, trueText = null, falseText = null }) => {
    const handleClick = () => {
        if (onChange)
            onChange(!value);
    };

    return (
        <Tooltip title={value ? trueText : falseText} arrow>
            <div onClick={handleClick} style={{ cursor: 'pointer' }} className={generateClassName("b2b-boolean-icon-toggle", "", className)}>
                {value ?
                    React.cloneElement(TrueIcon, { className: generateClassName("b2b-boolean-icon-toggle", "-true", className), ...TrueIcon.props })
                    :
                    React.cloneElement(FalseIcon, { className: generateClassName("b2b-boolean-icon-toggle", "-false", className), ...FalseIcon.props })
                }
            </div>
        </Tooltip>
    );
};

export default BooleanIconToggle;